var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.iconValue && _vm.iconValue.trim() !== ""
        ? _c(
            "q-btn",
            {
              staticClass: "no-margin no-padding",
              attrs: { small: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.popoverShowing = !_vm.popoverShowing
                }
              }
            },
            [
              _vm.template === "table"
                ? _c("q-icon", { attrs: { name: _vm.icon } })
                : _c("span", [_vm._v(_vm._s(_vm.iconValue))])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          _vm.popoverAction
            ? _c(
                "q-popover",
                {
                  attrs: { anchor: "bottom left", self: "top left" },
                  model: {
                    value: _vm.popoverShowing,
                    callback: function($$v) {
                      _vm.popoverShowing = $$v
                    },
                    expression: "popoverShowing"
                  }
                },
                [
                  _c(
                    "q-list",
                    {
                      staticClass: "q-body-1",
                      attrs: { link: "", separator: "" }
                    },
                    [
                      _c(
                        "q-item",
                        {
                          staticClass: "q-body-1",
                          on: { click: _vm.handleOpenAction }
                        },
                        [
                          _c("q-item-side", {
                            attrs: { icon: _vm.popoverAction.icon }
                          }),
                          _c("q-item-main", {
                            attrs: { label: _vm.popoverAction.label }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        {
                          directives: [
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:copy",
                              value: _vm.iconValue,
                              expression: "iconValue",
                              arg: "copy"
                            },
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:success",
                              value: _vm.handleCopy,
                              expression: "handleCopy",
                              arg: "success"
                            }
                          ],
                          staticClass: "q-body-1"
                        },
                        [
                          _c("q-item-side", {
                            attrs: { icon: "content_copy" }
                          }),
                          _c("q-item-main", {
                            attrs: { label: "Copy to Clipboard" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }